import React from 'react';
import PropTypes from 'prop-types';
import ProductPicker from '../Product/ProductPicker';
import SaveButton from '../Buttons/SaveButton';
import BackButton from '../Buttons/BackButton';
import FileComponent from '../File/AttachedFiles';
import textTranslates from './translate.json';
import ComplaintCheck from '../ComplaintPositionComponents/ComplaintCheck/ComplaintCheck';
import MountingAddress from '../ComplaintPositionComponents/MountingAddress/MountingAddress';
import * as fileTypes from '../File/FileAvailableCollections';
import SerialNumberWithTooltip from '../ComplaintPositionComponents/ArticleSerialNumber/SerialNumberWithTooltip';
import PurchaseAddressPicker from '../ComplaintPositionComponents/PurchaseAddress/PurchaseAddressPicker';
import FaultDescription from '../ComplaintPositionComponents/FaultDescription/FaultDescription';
import Amount from '../ComplaintPositionComponents/Amount/Amount';
import QuantityCorrectionsProposal from '../ComplaintPositionComponents/QuantityCorrectionsProposal/QuantityCorrectionsProposal';
import PurchaseDate from '../ComplaintPositionComponents/PurchaseDate/PurchaseDate';
import FaultDate from '../ComplaintPositionComponents/FaultDate/FaultDate';
import InvoiceQuantity from '../ComplaintPositionComponents/InvoiceQuantity/InvoiceQuantity';
import ShippedQuantity from '../ComplaintPositionComponents/ShippedQuantity/ShippedQuantity';
import {findComponentByComponentId} from '../../selectors/ComponentSelector';
import { QuestionGlyph } from '../glyphicons/Glyphicons';
import serwistag from '../../img/serwistag.png';
import { Tooltip,OverlayTrigger, Button, Popover } from 'react-bootstrap';

const ComplaintPositionForm = ({
    componentsToRender,
    couriers, 
    position, 
    onChange,
    onChangeCheck, 
    quantityCorrectionsProposals, 
    isSaving, 
    onFormSubmit,
    onAddPurchaseAddressButtonClick,
    onBackButtonClick,
    customerType}) => {
    

    function onDateChange(name, date) {
        onChange(name,date);
    }

    function onInputChange(event) {
        onChange(event.target.name, event.target.value);
    }

    function onNumericInputChange(event) {
        onChange(event.target.name, parseInt(event.target.value,10));
    }

    function onSelectChange(event) {
        onChange(event.target.name, {
            name: event.target.options[event.target.selectedIndex].getAttribute("name"),
            displayName: event.target.options[event.target.selectedIndex].text,
            id:event.target.options[event.target.selectedIndex].getAttribute("data-key")
        });
    }
    
    function onSubmit(event) {
        event.preventDefault();
        onFormSubmit(position);
    }
    let product = findComponentByComponentId(componentsToRender,'product');
    let amount = findComponentByComponentId(componentsToRender,'amount');
    let articleSerialNumber = findComponentByComponentId(componentsToRender,'articleSerialNumber');
    let articleAssemblyAddress = findComponentByComponentId(componentsToRender,'articleAssemblyAddress');
    let faultDescription = findComponentByComponentId(componentsToRender,'faultDescription');
    let quantityCorrectionsProposal = findComponentByComponentId(componentsToRender,'quantityCorrectionsProposal');
    let articlePurchaseDate = findComponentByComponentId(componentsToRender,'articlePurchaseDate');
    let faultDate = findComponentByComponentId(componentsToRender,'faultDate');
    let articleIsNecessaryForBusiness = findComponentByComponentId(componentsToRender,'articleIsNecessaryForBusiness');
    let articleIsCompleted = findComponentByComponentId(componentsToRender,'articleIsCompleted');
    let articleHasDisassemblySigns = findComponentByComponentId(componentsToRender,'articleHasDisassemblySigns');
    let purchaseProve = findComponentByComponentId(componentsToRender,'purchaseProve');
    let additionalFiles = findComponentByComponentId(componentsToRender,'additionalFiles');
    let invoiceQuantity = findComponentByComponentId(componentsToRender,'invoiceQuantity');
    let shippedQuantity = findComponentByComponentId(componentsToRender,'shippedQuantity');
    let faultDiscoveryCircumstances = findComponentByComponentId(componentsToRender,'faultDiscoveryCircumstances');
    let customerRequest = findComponentByComponentId(componentsToRender,'customerRequest');
    let salesDocumentNumber = findComponentByComponentId(componentsToRender,'salesDocumentNumber');
    let salesDocumentPosition = findComponentByComponentId(componentsToRender,'salesDocumentPosition');
    let shipmentDescription = findComponentByComponentId(componentsToRender,'shipmentDescription');
    let dateOfReceiptOfGoods = findComponentByComponentId(componentsToRender,'dateOfReceiptOfGoods');
    let courier = findComponentByComponentId(componentsToRender,'courier');
    let purchaseAddressInput = findComponentByComponentId(componentsToRender,'purchaseAddressInput');


    const popoverHoverFocus = (
    <Popover id="popover-trigger-hover-focus">
        <img src={serwistag} style={{width:'200px', height:'100px'}}/>
    </Popover>
    );
    const labelPhotoInfo = (
        <div>
          <span style={{color:'red'}}>
            UWAGA! W tym miejscu należy umieścić zdjęcie srebrnej etykiety gwarancyjnej reklamowanego produktu.
            {/* <OverlayTrigger placement='top' overlay={<Tooltip id="tooltip-top"><img src={serwistag} alt='tooltip image'/></Tooltip>}>
              <QuestionGlyph className="in" onMouseEnter={(e) => e.target.click()} />
            </OverlayTrigger> */}
          
            
            <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="top"
            overlay={popoverHoverFocus}
            >
              <a style={{color:'red', fontSize:'1.3em', textDecoration:'none'}}><QuestionGlyph /></a>
            </OverlayTrigger>
      </span>
   
        </div>
      );
    return(
        <form
            onSubmit={onSubmit} >

                
            {amount != undefined? 
                <div>
                    <ProductPicker 
                        inputId={amount.componentId}/>
                    <Amount
                        label={textTranslates.amount.label}
                        onChange={onNumericInputChange}
                        placeholder={textTranslates.amount.placeholder}
                        value={position.amount} />
                </div>:null   
            }

            {articleSerialNumber != undefined?
                <SerialNumberWithTooltip
                    id={articleSerialNumber.componentId}
                    label={articleSerialNumber.label}
                    name={articleSerialNumber.componentId}
                    onChange={onInputChange}
                    placeholder={articleSerialNumber.placeholder}
                    value={position.articleSerialNumber} />:null
            }

            {articleAssemblyAddress != undefined?
                <MountingAddress
                    placeholder = {articleAssemblyAddress.placeholder}
                    label={articleAssemblyAddress.label}
                    name={articleAssemblyAddress.componentId}
                    value={position.articleAssemblyAddress}
                    onChange={onInputChange}/>:null
            }
            
            {/* TODO */}
            {purchaseAddressInput != undefined && customerType.value === "PrivatePerson" ?
                <div>
                    <PurchaseAddressPicker
                        onPickerButtonClick={onAddPurchaseAddressButtonClick} />
                </div>
                :<div></div>
            }

            {faultDescription != undefined?
                <FaultDescription
                    placeholder = {faultDescription.placeholder}
                    label={faultDescription.label}
                    name={faultDescription.componentId}
                    value={position.faultDescription}
                    onChange={onInputChange}/>:null
            }

            {quantityCorrectionsProposal != undefined?
                <QuantityCorrectionsProposal
                    name={quantityCorrectionsProposal.componentId}
                    label={textTranslates.complaint.resolve}
                    values={quantityCorrectionsProposals}
                    onChange={onSelectChange}
                     />:null
            }

            {articlePurchaseDate != undefined ?
                <PurchaseDate
                    label={articlePurchaseDate.label}
                    id={articlePurchaseDate.componentId}
                    onChange={onDateChange}
                    selectedDate={position.articlePurchaseDate} />
                : null
            }

            {faultDate != undefined ?
                <FaultDate
                    label={textTranslates.complaint.purchaseDate}
                    onChange={onDateChange}
                    selectedDate={position.faultDate}/>:null
            }

            {articleIsNecessaryForBusiness != undefined ?
                <ComplaintCheck 
                    onChange={onChangeCheck}
                    label={articleIsNecessaryForBusiness.label}
                    name={"articleIsNecessaryForBusiness"}
                    id={"articleIsNecessaryForBusiness"}
                    value={position.articleIsNecessaryForBusiness} />:null
            }

            {articleIsCompleted != undefined ?
                <ComplaintCheck 
                    onChange={onChangeCheck}
                    label={textTranslates.complaint.ArticleIsCompleted}
                    name={"articleIsCompleted"}
                    id={"articleIsCompleted"}
                    value={position.ArticleIsCompleted} />:null
            }

            {articleHasDisassemblySigns != undefined ?
                <ComplaintCheck
                    onChange={onChangeCheck}
                    label={textTranslates.complaint.ArticleHasDisassemblySigns}
                    name={"articleHasDisassemblySigns"}
                    id={"articleHasDisassemblySigns"}
                    value={position.hasArticleDissassemblySigns} />:null
            }

            {purchaseProve != undefined ?
                <FileComponent 
                    id={"purchaseProve"}
                    filesDescriptionText={textTranslates.complaint.purchaseProve}
                    filesTargetName={fileTypes.purchaseProveFiles}
                    title={"Dowód zakupu *"} />:null
            }

            {additionalFiles != undefined ?
          
                <FileComponent 
                    id={"additionalFiles"}
                    labelPhotoText = {labelPhotoInfo}
                    filesDescriptionText={textTranslates.complaint.files}
                    filesTargetName={fileTypes.files}
                    title={additionalFiles.label} />:null
            }
            

            {invoiceQuantity != undefined ?
                <InvoiceQuantity
                    id={invoiceQuantity.componentId}
                    label={invoiceQuantity.label}
                    name={invoiceQuantity.componentId}
                    onChange={onInputChange}
                    placeholder={invoiceQuantity.placeholder}
                    value={position.invoiceQuantity} />:null
            }

            {shippedQuantity != undefined?
                <ShippedQuantity
                    id={shippedQuantity.componentId}
                    label={shippedQuantity.label}
                    name={shippedQuantity.componentId}
                    onChange={onInputChange}
                    placeholder={shippedQuantity.placeholder}
                    value={position.shippedQuantity} />:null}

            {faultDiscoveryCircumstances != undefined ?
                <InputWithLabel
                    className="col-xs-12"
                    id={faultDiscoveryCircumstances.componentId}
                    inputDivClassName="col-xs-12 col-sm-8"
                    label={faultDiscoveryCircumstances.label}
                    name={faultDiscoveryCircumstances.componentId}
                    onChange={onInputChange}
                    placeholder={faultDiscoveryCircumstances.placeholder}
                    type="text"
                    value={position.faultDiscoveryCircumstances} />:null }

            {customerRequest != undefined ?
                <InputWithLabel
                    className="col-xs-12"
                    id={customerRequest.componentId}
                    inputDivClassName="col-xs-12 col-sm-8"
                    label={customerRequest.label}
                    name={customerRequest.componentId}
                    onChange={onInputChange}
                    placeholder={customerRequest.placeholder}
                    type="text"
                    value={position.customerRequest} />:null}

            {salesDocumentNumber != undefined ?
                <InputWithLabel
                    className="col-xs-12"
                    id={salesDocumentNumber.componentId}
                    inputDivClassName="col-xs-12 col-sm-6"
                    label={salesDocumentNumber.label}
                    name={salesDocumentNumber.componentId}
                    onChange={onInputChange}
                    placeholder={salesDocumentNumber.placeholder}
                    type="text"
                    value={position.salesDocumentNumber}/>:null}

            {salesDocumentPosition != undefined ?
                <InputWithLabel
                    className="col-xs-12"
                    id={salesDocumentPosition.componentId}
                    inputDivClassName="col-xs-12 col-sm-6"
                    label={salesDocumentPosition.label}
                    name={salesDocumentPosition.componentId}
                    onChange={onInputChange}
                    placeholder={salesDocumentPosition.placeholder}
                    type="text"
                    value={position.salesDocumentPosition}/>:null}

            {shipmentDescription != undefined ?
                <InputWithLabel
                    className="col-xs-12"
                    id={shipmentDescription.componentId}
                    inputDivClassName="col-xs-12 col-sm-8"
                    label={shipmentDescription.label}
                    name={shipmentDescription.componentId}
                    onChange={onInputChange}
                    placeholder={shipmentDescription.placeholder}
                    type="text"
                    value={position.shipmentDescription} />:null}

            {dateOfReceiptOfGoods != undefined ?
                <LabeledDatePicker
                    className="col-xs-12"
                    id={dateOfReceiptOfGoods.componentId}
                    inputDivClassName="col-xs-12 col-sm-2"
                    label={dateOfReceiptOfGoods.label}
                    name={dateOfReceiptOfGoods.componentId}
                    onChange={onDateChange}
                    selectedDate={position.dateOfReceiptOfGoods} />:null}

            {courier != undefined ?
                <Select
                    className="col-xs-12"
                    inputClassName="col-xs-12 col-sm-6"
                    label={courier.label}
                    name={courier.componentId}
                    values={couriers}
                    onChange={onSelectChange}
                    value={position.courier.value} />:null}

            <div className="col-xs-12">
                <BackButton
                    onBackButtonClick={onBackButtonClick} />
                <SaveButton
                    disabled={isSaving}
                    type="submit" />
            </div>
        </form>
    );
};

ComplaintPositionForm.propTypes = {
    componentsToRender: PropTypes.array,
    position: PropTypes.object,
    complaintType: PropTypes.object,
    onChange: PropTypes.func,
    couriers: PropTypes.array,
    quantityCorrectionsProposals: PropTypes.array,
    onCancelClick: PropTypes.func,
    isSaving: PropTypes.bool,
    onFormSubmit: PropTypes.func
};

export default ComplaintPositionForm;


// WEBPACK FOOTER //
// ./src/components/MenageComplaintPosition/ComplaintPositionForm.js